import React, { useState, useCallback, useEffect, useRef } from 'react';
import Select from 'react-select';
import axios from 'axios';
//import { Editor } from "@tinymce/tinymce-react";
import { EditorState, convertFromHTML, ContentState } from 'draft-js';
import { Editor, EditorState as DraftEditorState } from "react-draft-wysiwyg";
import Moment from 'moment';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { stateToHTML } from 'draft-js-export-html';
import Layout from '../components/layout'
const customStyles = {
    control: (styles) => ({
        ...styles,

        fontSize: '14px',               // Change font size
        color: '#333',                  // Change font color

    }),
    singleValue: (styles) => ({
        ...styles,
        fontSize: '14px',
        color: '#555',
    }),
    option: (styles) => ({
        ...styles,

        fontSize: '16px',
        color: '#444',
    }),
}
const FormPage1 = ({ editorStates, formData, handleSelectChange, handleMultiSelectChange, handleChange, onEditorStateChange, insertImage, errors, requiredFields }) => {





    const domainOptions = [
        { value: 'Maltreatment', label: 'Maltreatment' },
        { value: 'Decisional capabilities', label: 'Decisional capabilities' },
        { value: 'Functional status', label: 'Functional status' },
        { value: 'Risk assessment', label: 'Risk assessment' }
    ];

    const subDomainOptions = [
        { value: 'Maltreatment (broad)', label: 'Maltreatment (broad)' },
        { value: 'Financial', label: 'Financial' },
        { value: 'Neglect', label: 'Neglect' },
        { value: 'Physical', label: 'Physical' },
        { value: 'Psychological', label: 'Psychological' },
        { value: 'Self-neglect', label: 'Self-neglect' },
        { value: 'Sexual', label: 'Sexual' },
        { value: 'Other', label: 'Other' }
    ];
    const fieldOptions = [
        { value: 'Social/human services', label: 'Social/human services' },
        { value: 'Research', label: 'Research' },
        { value: 'Healthcare', label: 'Healthcare' },
        { value: 'Legal', label: 'Legal' },
        { value: 'Financial services', label: 'Financial services' },

    ];

    const administeredByOptions = [
        { value: 'Professional', label: 'Professional' },
        { value: 'Proxy', label: 'Proxy' },
        { value: 'Self-administered', label: 'Self-administered' },
        { value: 'Self-administered (followed by an interview with a professional)', label: 'Self-administered (followed by an interview with a professional)' },
        { value: 'Self-administered and professional', label: 'Self-administered and professional' },
        { value: 'Caregiver', label: 'Caregiver' },
        { value: 'Unknown', label: 'Unknown' }
    ];
    const formatOptions = [
        { value: 'Questionnaire', label: 'Questionnaire' },
        { value: 'Observation', label: 'Observation' },
        { value: 'Interview/questionnaire', label: 'Interview/questionnaire' },
        { value: 'Computer-administered', label: 'Computer-administered' },
        { value: 'Rating scale', label: 'Rating scale' },
        { value: 'Vignette-based tool', label: 'Vignette-based tool' },
        { value: 'Behavioral tasks', label: 'Behavioral tasks' },
        { value: 'Performance Measure', label: 'Performance Measure' },
        { value: 'Informant', label: 'Informant' }
    ];
    const trainingRequiredOptions = [
        { value: 'No training required', label: 'No training required' },
        { value: 'Brief training required (less than 3 hours)', label: 'Brief training required (less than 3 hours)' },
        { value: 'Some training required (between 4-8 hours)', label: 'Some training required (between 4-8 hours)' },
        { value: 'Moderate training required (8-16 hours)', label: 'Moderate training required (8-16 hours)' },
        { value: 'Extensive training required (17+ hours)', label: 'Extensive training required (17+ hours)' },
        { value: 'Professional qualifications', label: 'Professional qualifications' },
        { value: 'Unknown', label: 'Unknown' },
    ];


    const copyrightAndAccessOptions = [
        { value: 'Not found', label: 'Not found' },
        { value: 'Copyrighted', label: 'Copyrighted' },
        { value: 'Not copyrighted', label: 'Not copyrighted' },
        { value: 'Write for permission to use', label: 'Write for permission to use' },
        { value: 'Give credit', label: 'Give credit' },
        { value: 'Free to use', label: 'Free to use' },
        { value: 'For purchase', label: 'For purchase' },

    ];

    const levelOfEvidenceOptions = [
        { value: 'Well Supported/Supported', label: 'Well Supported/Supported' },
        { value: 'Not yet established', label: 'Not yet established' },
        { value: 'Promising/Emerging', label: 'Promising/Emerging' },
        { value: 'Unsupported', label: 'Unsupported' },
    ];

    return (
        <div>


            <div className="grid grid-cols-1 gap-6 lg:grid-cols-2 p-8">

                <div className="form-group">
                    <label htmlFor="toolName" className="block text-sm font-medium text-gray-700">Tool Name <span className="text-red-700">*</span></label>
                    <input
                        type="text"
                        id="toolName"
                        name="toolName"
                        className="mt-1 p-2 w-full border border-gray-300 rounded-md"
                        value={formData.toolName}
                        onChange={handleChange}
                        required={requiredFields.includes('toolName')}
                    />
                    {errors.toolName && <span className="text-sm" style={{ color: '#AC0C0C' }}>This is a required field</span>}

                </div>

                <div className="form-group">
                    <label htmlFor="domain" className="block text-sm font-medium text-gray-700">Domain <span className="text-red-700">*</span>
                    </label>
                    <Select

                        inputId="domain"
                        styles={customStyles}
                        options={domainOptions}
                        value={domainOptions.find((option) => option.value === formData.domain)}
                        onChange={(value) => handleSelectChange('domain', value)}
                        className="mt-1"
                        required={requiredFields.includes('domain')} //
                    />
                    {errors.domain && <span className="text-sm" style={{ color: '#AC0C0C' }}>This is a required field</span>}
                </div>



                <div className="form-group">
                    <label htmlFor="domainSubType" className="block text-sm font-medium text-gray-700">Sub Domain-Type <span className="text-xs text-gray-500 mt-1">
                        (Select one or more options from the list.)</span></label>
                    <Select
                        isMulti
                        inputId="domainSubType"
                        options={subDomainOptions}
                        value={subDomainOptions.filter((option) => formData.domainSubType.includes(option.value))}
                        onChange={(selectedOptions) => handleMultiSelectChange('domainSubType', selectedOptions)}
                        className="mt-1"

                    />
                </div>

                <div className="form-group">
                    <label htmlFor="maltreatmentSubTypeOther" className="block text-sm font-medium text-gray-700">Maltreatment SubType : Other</label>
                    <input
                        type="text"
                        id="maltreatmentSubTypeOther"
                        name="maltreatmentSubTypeOther"
                        className="mt-1 p-2 w-full border border-gray-300 rounded-md"
                        value={formData.maltreatmentSubTypeOther}
                        onChange={handleChange}
                    />
                </div>




                <div className="form-group">
                    <label htmlFor="description" className="block text-sm font-medium text-gray-700">Description <span className="text-red-700">*</span></label>

                    <Editor

                        editorState={editorStates.description}                        
                        onEditorStateChange={(newEditorState) => onEditorStateChange('description', newEditorState)}
                        toolbarCustomButtons={[<doCollapse />]}
                        wrapperClassName="demo-wrapper"
                        editorClassName="demo-editor"
                        toolbarClassName="demo-toolbar-absolute"
                        toolbarOnFocus

                        required={requiredFields.includes('description')}
                    />
                    {errors.description && <span className="text-sm" style={{ color: '#AC0C0C' }}>This is a required field</span>}
                </div>


                <div className="form-group">
                    <label htmlFor="originalToolName" className="block text-sm font-medium text-gray-700">Name of Original Tool</label>
                    <input
                        type="text"
                        id="originalToolName"
                        name="originalToolName"
                        className="mt-1 p-2 w-full border border-gray-300 rounded-md"
                        value={formData.originalToolName}
                        onChange={handleChange}
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="applicableFields" className="block text-sm font-medium text-gray-700">Applicable Fields <span className="text-red-700">* </span><span className="text-xs text-gray-500 mt-1">
                        (Select one or more options from the list.)</span></label>
                    <Select
                        defaultValue={[]}
                        isMulti
                        inputId="applicableFields"
                        options={fieldOptions}
                        value={fieldOptions.filter((option) =>
                            formData.applicableFields.includes(option.value)
                        )}
                        onChange={(selectedOptions) =>
                            handleMultiSelectChange('applicableFields', selectedOptions)
                        }

                        className="mt-1"
                        required={requiredFields.includes('applicableFields')}
                    />
                    {errors.applicableFields && <span className="text-sm" style={{ color: '#AC0C0C' }}>This is a required field</span>}

                </div>

                <div className="form-group">
                    <label htmlFor="administeredBy" className="block text-sm font-medium text-gray-700">Administered By <span className="text-red-700">* </span><span className="text-xs text-gray-500 mt-1">
                        (Select one or more options from the list.)</span></label>
                    <Select
                        isMulti
                        inputId="administeredBy"
                        options={administeredByOptions}
                        value={administeredByOptions.filter((option) =>
                            formData.administeredBy.includes(option.value)
                        )}
                        onChange={(selectedOptions) =>
                            handleMultiSelectChange('administeredBy', selectedOptions)
                        }
                        className="mt-1"
                        required={requiredFields.includes('administeredBy')} //
                    />
                    {errors.administeredBy && <span className="text-sm" style={{ color: '#AC0C0C' }}>This is a required field</span>}

                </div>

                <div className="form-group">
                    <label htmlFor="administeredByDetails" className="block text-sm font-medium text-gray-700">Administered By Details</label>
                    <input
                        type="text"
                        id="administeredByDetails"
                        name="administeredByDetails"
                        className="mt-1 p-2 w-full border border-gray-300 rounded-md"
                        value={formData.administeredByDetails}
                        onChange={handleChange}
                    />
                </div>


                <div className="form-group">
                    <label htmlFor="format" className="block text-sm font-medium text-gray-700">Format <span className="text-red-700">* </span><span className="text-xs text-gray-500 mt-1">
                        (Select one or more options from the list.)</span></label>
                    <Select
                        isMulti
                        inputId="format"
                        options={formatOptions}
                        value={formatOptions.filter((option) =>
                            formData.format.includes(option.value)
                        )}
                        onChange={(selectedOptions) =>
                            handleMultiSelectChange('format', selectedOptions)
                        }
                        className="mt-1"
                        required={requiredFields.includes('format')} //
                    />
                    {errors.format && <span className="text-sm" style={{ color: '#AC0C0C' }}>This is a required field</span>}
                </div>
                <div className="form-group">
                    <label htmlFor="formatDetail" className="block text-sm font-medium text-gray-700">Format Detail</label>
                    <textarea
                        id="formatDetail"
                        name="formatDetail"
                        className="mt-1 p-2 w-full border border-gray-300 rounded-md"
                        value={formData.formatDetail}
                        onChange={handleChange}
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="numOfItems" className="block text-sm font-medium text-gray-700">Number of Items <span className="text-red-700">*</span></label>
                    <input
                        type="text"
                        id="numOfItems"
                        name="numOfItems"
                        className="mt-1 p-2 w-full border border-gray-300 rounded-md"
                        value={formData.numOfItems}
                        onChange={handleChange}
                        required={requiredFields.includes('numOfItems')} //
                    />
                    {errors.numOfItems && <span className="text-sm" style={{ color: '#AC0C0C' }}>This is a required field</span>}
                </div>

                <div className="form-group">
                    <label htmlFor="adminLength" className="block text-sm font-medium text-gray-700">Administration Length <span className="text-red-700">*</span></label>
                    <input
                        type="text"
                        id="adminLength"
                        name="adminLength"
                        className="mt-1 p-2 w-full border border-gray-300 rounded-md"
                        value={formData.adminLength}
                        onChange={handleChange}
                        required={requiredFields.includes('adminLength')} //
                    />
                    {errors.adminLength && <span className="text-sm" style={{ color: '#AC0C0C' }}>This is a required field</span>}
                </div>

                <div className="form-group">
                    <label htmlFor="trainingRequired" className="block text-sm font-medium text-gray-700">Training Required <span className="text-red-700">*</span></label>
                    <Select
                        inputId="trainingRequired"
                        options={trainingRequiredOptions}
                        value={trainingRequiredOptions.find((option) => option.value === formData.trainingRequired)}
                        onChange={(value) => handleSelectChange('trainingRequired', value)}
                        className="mt-1"
                        required={requiredFields.includes('trainingRequired')} //
                    />
                    {errors.trainingRequired && <span className="text-sm" style={{ color: '#AC0C0C' }}>This is a required field</span>}
                </div>

                <div className="form-group">
                    <label htmlFor="trainingRequiredDetail" className="block text-sm font-medium text-gray-700">Training Required Detail</label>
                    <textarea
                        id="trainingRequiredDetail"
                        name="trainingRequiredDetail"
                        className="mt-1 p-2 w-full border border-gray-300 rounded-md"
                        value={formData.trainingRequiredDetail}
                        onChange={handleChange}
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="language" className="block text-sm font-medium text-gray-700">Language <span className="text-red-700">*</span></label>
                    <input
                        type="text"
                        id="language"
                        name="language"
                        className="mt-1 p-2 w-full border border-gray-300 rounded-md"
                        value={formData.languageOptions}
                        onChange={handleChange}
                        required={requiredFields.includes('language')} //
                    />
                    {errors.language && <span className="text-sm" style={{ color: '#AC0C0C' }}>This is a required field</span>}
                </div>


                <div className="form-group">
                    <label htmlFor="copyrightAndAccess" className="block text-sm font-medium text-gray-700">Copyright and Access <span className="text-red-700">* </span><span className="text-xs text-gray-500 mt-1">
                        (Select one or more options from the list.)</span></label>
                    <Select
                        isMulti
                        inputId="copyrightAndAccess"
                        options={copyrightAndAccessOptions}
                        value={copyrightAndAccessOptions.filter((option) =>
                            formData.copyrightAndAccess.includes(option.value)
                        )}
                        onChange={(selectedOptions) =>
                            handleMultiSelectChange('copyrightAndAccess', selectedOptions)
                        }

                        className="mt-1"
                        required={requiredFields.includes('copyrightAndAccess')} //
                    />
                    {errors.copyrightAndAccess && <span className="text-sm" style={{ color: '#AC0C0C' }}>This is a required field</span>}
                </div>
                <div className="form-group">
                    <label htmlFor="copyrightandAccessDetailsandContact" className="block text-sm font-medium text-gray-700">Copyright and Access Details and Contact</label>
                    <input
                        type="text"
                        id="copyrightandAccessDetailsandContact"
                        name="copyrightandAccessDetailsandContact"
                        className="mt-1 p-2 w-full border border-gray-300 rounded-md"
                        value={formData.copyrightandAccessDetailsandContact}
                        onChange={handleChange}
                    />
                </div>



                <div className="form-group">
                    <label htmlFor="linkToTool" className="block text-sm font-medium text-gray-700">Link to the Tool <span className="text-red-700">*</span></label>
                    <input
                        type="text"
                        id="linkToTool"
                        name="linkToTool"
                        className="mt-1 p-2 w-full border border-gray-300 rounded-md"
                        value={formData.linkToTool}
                        onChange={handleChange}
                        required={requiredFields.includes('linkToTool')}
                    />
                    {errors.linkToTool && <span className="text-sm" style={{ color: '#AC0C0C' }}>This is a required field</span>}
                </div>

                <div className="form-group">
                    <label htmlFor="contactInformation" className="block text-sm font-medium text-gray-700">Contact Information <span className="text-red-700">*</span></label>
                    <input
                        type="text"
                        id="contactInformation"
                        name="contactInformation"
                        className="mt-1 p-2 w-full border border-gray-300 rounded-md"
                        value={formData.contactInformation}
                        onChange={handleChange}
                        required={requiredFields.includes('contactInformation')}
                    />
                    {errors.contactInformation && <span className="text-sm" style={{ color: '#AC0C0C' }}>This is a required field</span>}
                </div>

                <div className="form-group">
                    <label htmlFor="originalPopulation" className="block text-sm font-medium text-gray-700">Original Population <span className="text-red-700">*</span></label>
                    <input
                        type="text"
                        id="originalPopulation"
                        name="originalPopulation"
                        className="mt-1 p-2 w-full border border-gray-300 rounded-md"
                        value={formData.originalPopulation}
                        onChange={handleChange}
                        required={requiredFields.includes('originalPopulation')}
                    />
                    {errors.originalPopulation && <span className="text-sm" style={{ color: '#AC0C0C' }}>This is a required field</span>}
                </div>

                <div className="form-group">
                    <label htmlFor="additionalPopulations" className="block text-sm font-medium text-gray-700">Additional Populations</label>
                    <input
                        type="text"
                        id="additionalPopulations"
                        name="additionalPopulations"
                        className="mt-1 p-2 w-full border border-gray-300 rounded-md"
                        value={formData.additionalPopulations}
                        onChange={handleChange}
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="originalSetting" className="block text-sm font-medium text-gray-700">Original Setting <span className="text-red-700">*</span></label>
                    <input
                        type="text"
                        id="originalSetting"
                        name="originalSetting"
                        className="mt-1 p-2 w-full border border-gray-300 rounded-md"
                        value={formData.originalSetting}
                        onChange={handleChange}
                        required={requiredFields.includes('originalSetting')}
                    />
                    {errors.originalSetting && <span className="text-sm" style={{ color: '#AC0C0C' }}>This is a required field</span>}
                </div>

                <div className="form-group">
                    <label htmlFor="additionalSetting" className="block text-sm font-medium text-gray-700">Additional Setting</label>
                    <input
                        type="text"
                        id="additionalSetting"
                        name="additionalSetting"
                        className="mt-1 p-2 w-full border border-gray-300 rounded-md"
                        value={formData.additionalSetting}
                        onChange={handleChange}
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="overallLevelofEvidence" className="block text-sm font-medium text-gray-700">Overall Level of Evidence <span className="text-red-700">*</span></label>
                    <Select
                        inputId="overallLevelofEvidence"
                        options={levelOfEvidenceOptions}
                        value={levelOfEvidenceOptions.find((option) => option.value === formData.overallLevelofEvidence)}
                        onChange={(value) => handleSelectChange('overallLevelofEvidence', value)}
                        className="mt-1"
                        required={requiredFields.includes('overallLevelofEvidence')}
                    />
                    {errors.overallLevelofEvidence && <span className="text-sm" style={{ color: '#AC0C0C' }}>This is a required field</span>}
                </div>


                <div className="form-group">
                    <label htmlFor="areasofStrength" className="block text-sm font-medium text-gray-700">Areas of Strength <span className="text-red-700">*</span></label>

                    <Editor
                        editorState={editorStates.areasofStrength}
                        toolbarCustomButtons={[<doCollapse />]}
                        wrapperClassName="demo-wrapper"
                        editorClassName="demo-editor"
                        toolbarClassName="demo-toolbar-absolute"
                        toolbarOnFocus
                        onEditorStateChange={(newEditorState) => onEditorStateChange('areasofStrength', newEditorState)}
                        required={requiredFields.includes('areasofStrength')} //
                    />
                    {errors.areasofStrength && <span className="text-sm" style={{ color: '#AC0C0C' }}>This is a required field</span>}
                </div>

                <div className="form-group">
                    <label htmlFor="recommendationsforFurtherValidation" className="block text-sm font-medium text-gray-700">Recommendations for Further Validation <span className="text-red-700">*</span></label>

                    <Editor
                        editorState={editorStates.recommendationsforFurtherValidation}
                        wrapperClassName="demo-wrapper"
                        toolbarClassName="demo-toolbar-absolute"
                        toolbarOnFocus
                        editorClassName="demo-editor"
                        onEditorStateChange={(newEditorState) => onEditorStateChange('recommendationsforFurtherValidation', newEditorState)}
                        required={requiredFields.includes('recommendationsforFurtherValidation')} //
                    />
                    {errors.recommendationsforFurtherValidation && <span className="text-sm" style={{ color: '#AC0C0C' }}>This is a required field</span>}
                </div>
            </div>
            <br />
        </div>

    );
};

const FormPage2 = ({ formData, editorStates, handleSelectChange, handleMultiSelectChange, handleChange, onEditorStateChange, insertImage, errors, requiredFields }) => {
    //const [subDomainOptions, setSubDomainOptions] = useState([]);
    const ratingresultOptions = [
        { value: 'Promising/Emerging', label: 'Promising/Emerging' },
        { value: 'Not yet established', label: 'Not yet established' },
        { value: 'Well Supported/Supported', label: 'Well Supported/Supported' },
        { value: 'Unsupported', label: 'Unsupported' },
    ];

    const levelOfEvidenceOptions = [
        { value: 'Well Supported/Supported', label: 'Well Supported/Supported' },
        { value: 'Not yet established', label: 'Not yet established' },
        { value: 'Promising/Emerging', label: 'Promising/Emerging' },
        { value: 'Unsupported', label: 'Unsupported' },
    ];

    return (
        <div>


            <div className="grid grid-cols-1 gap-6 lg:grid-cols-2 p-8">
                <div className="form-group">
                    <label htmlFor="references" className="block text-sm font-medium text-gray-700">References <span className="text-red-700">*</span></label>

                    <Editor
                        editorState={editorStates.references}
                        wrapperClassName="demo-wrapper"
                        toolbarClassName="demo-toolbar-absolute"
                        toolbarOnFocus
                        editorClassName="demo-editor"
                        onEditorStateChange={(newEditorState) => onEditorStateChange('references', newEditorState)}
                        required={requiredFields.includes('references')} //
                    />
                    {errors.references && <span className="text-sm" style={{ color: '#AC0C0C' }}>This is a required field</span>}
                </div>




                <div className="form-group">
                    <label htmlFor="levelOfEvidence" className="block text-sm font-medium text-gray-700">Level of Evidence <span className="text-red-700">*</span></label>
                    <Select
                        inputId="levelOfEvidence"
                        options={levelOfEvidenceOptions}
                        value={levelOfEvidenceOptions.find((option) => option.value === formData.levelOfEvidence)}
                        onChange={(value) => handleSelectChange('levelOfEvidence', value)}
                        className="mt-1"
                        required={requiredFields.includes('levelOfEvidence')} //
                    />
                    {errors.levelOfEvidence && <span className="text-sm" style={{ color: '#AC0C0C' }}>This is a required field</span>}
                </div>

                <div className="form-group">
                    <label htmlFor="dimension1UsefulnessSupportingDocs" className="block text-sm font-medium text-gray-700">Dimension 1: Usefulness - Supporting Documentation <span className="text-red-700">*</span></label>

                    <Editor
                        editorState={editorStates.dimension1UsefulnessSupportingDocs}
                        wrapperClassName="demo-wrapper"
                        toolbarClassName="demo-toolbar-absolute"
                        toolbarOnFocus
                        editorClassName="demo-editor"
                        onEditorStateChange={(newEditorState) => onEditorStateChange('dimension1UsefulnessSupportingDocs', newEditorState)}
                        required={requiredFields.includes('dimension1UsefulnessSupportingDocs')} //
                    />
                    {errors.dimension1UsefulnessSupportingDocs && <span className="text-sm" style={{ color: '#AC0C0C' }}>This is a required field</span>}
                </div>


                <div className="form-group">
                    <label htmlFor="dimension1UsefulnessRating" className="block text-sm font-medium text-gray-700">Dimension 1: Usefulness - Rating <span className="text-red-700">*</span></label>
                    <Select
                        inputId="dimension1UsefulnessRating"
                        options={ratingresultOptions}
                        value={ratingresultOptions.find((option) => option.value === formData.dimension1UsefulnessRating)}
                        onChange={(value) => handleSelectChange('dimension1UsefulnessRating', value)}
                        className="mt-1"
                        required={requiredFields.includes('dimension1UsefulnessRating')} //
                    />
                    {errors.dimension1UsefulnessRating && <span className="text-sm" style={{ color: '#AC0C0C' }}>This is a required field</span>}
                </div>



                <div className="form-group">
                    <label htmlFor="dimension1UsefulnessStrength" className="block text-sm font-medium text-gray-700">Dimension 1: Usefulness - Areas of Strength <span className="text-red-700">*</span></label>

                    <Editor
                        editorState={editorStates.dimension1UsefulnessStrength}
                        wrapperClassName="demo-wrapper"
                        toolbarClassName="demo-toolbar-absolute"
                        toolbarOnFocus
                        editorClassName="demo-editor"
                        onEditorStateChange={(newEditorState) => onEditorStateChange('dimension1UsefulnessStrength', newEditorState)}
                        required={requiredFields.includes('dimension1UsefulnessStrength')} //
                    />
                    {errors.dimension1UsefulnessStrength && <span className="text-sm" style={{ color: '#AC0C0C' }}>This is a required field</span>}
                </div>

                <div className="form-group">
                    <label htmlFor="dimension1UsefulnessRecommendations" className="block text-sm font-medium text-gray-700">Dimension 1: Usefulness - Recommendations for Further Validation <span className="text-red-700">*</span></label>

                    <Editor
                        editorState={editorStates.dimension1UsefulnessRecommendations}
                        wrapperClassName="demo-wrapper"
                        toolbarClassName="demo-toolbar-absolute"
                        toolbarOnFocus
                        editorClassName="demo-editor"
                        onEditorStateChange={(newEditorState) => onEditorStateChange('dimension1UsefulnessRecommendations', newEditorState)}
                        required={requiredFields.includes('dimension1UsefulnessRecommendations')}
                    />
                    {errors.dimension1UsefulnessRecommendations && <span className="text-sm" style={{ color: '#AC0C0C' }}>This is a required field</span>}
                </div>


                {/* Add sections for each dimension */}

                <div className="form-group">
                    <label htmlFor="dimension2ReliabilityRating" className="block text-sm font-medium text-gray-700">Dimension 2: Internal Consistency & Reliability Rating Results  <span className="text-red-700">*</span></label>
                    <Select
                        inputId="dimension2ReliabilityRating"
                        options={ratingresultOptions}
                        value={ratingresultOptions.find((option) => option.value === formData.dimension2ReliabilityRating)}
                        onChange={(value) => handleSelectChange('dimension2ReliabilityRating', value)}
                        className="mt-1"
                        required={requiredFields.includes('dimension2ReliabilityRating')}
                    />
                    {errors.dimension2ReliabilityRating && <span className="text-sm" style={{ color: '#AC0C0C' }}>This is a required field</span>}
                </div>



                <div className="form-group">
                    <label htmlFor="dimension2ReliabilityStrength" className="block text-sm font-medium text-gray-700">Dimension 2: Internal Consistency & Reliability Areas of Strength <span className="text-red-700">*</span></label>

                    <Editor
                        editorState={editorStates.dimension2ReliabilityStrength}
                        wrapperClassName="demo-wrapper"
                        toolbarClassName="demo-toolbar-absolute"
                        toolbarOnFocus
                        editorClassName="demo-editor"
                        onEditorStateChange={(newEditorState) => onEditorStateChange('dimension2ReliabilityStrength', newEditorState)}
                        required={requiredFields.includes('dimension2ReliabilityStrength')}
                    />
                    {errors.dimension2ReliabilityStrength && <span className="text-sm" style={{ color: '#AC0C0C' }}>This is a required field</span>}
                </div>


                <div className="form-group">
                    <label htmlFor="dimension2ReliabilitySupportingDocs" className="block text-sm font-medium text-gray-700">Dimension 2: Internal Consistency & Reliability
                        Supporting Documentation <span className="text-red-700">*</span></label>

                    <Editor
                        editorState={editorStates.dimension2ReliabilitySupportingDocs}
                        wrapperClassName="demo-wrapper"
                        toolbarClassName="demo-toolbar-absolute"
                        toolbarOnFocus
                        editorClassName="demo-editor"
                        onEditorStateChange={(newEditorState) => onEditorStateChange('dimension2ReliabilitySupportingDocs', newEditorState)}
                        required={requiredFields.includes('dimension2ReliabilitySupportingDocs')} //
                    />
                    {errors.dimension2ReliabilitySupportingDocs && <span className="text-sm" style={{ color: '#AC0C0C' }}>This is a required field</span>}
                </div>



                <div className="form-group">
                    <label htmlFor="dimension2ReliabilityRecommendations" className="block text-sm font-medium text-gray-700">Dimension 2: Internal Consistency & Reliability
                        Recommendations for Further Validation <span className="text-red-700">*</span></label>

                    <Editor
                        editorState={editorStates.dimension2ReliabilityRecommendations}
                        wrapperClassName="demo-wrapper"
                        toolbarClassName="demo-toolbar-absolute"
                        toolbarOnFocus
                        editorClassName="demo-editor"
                        onEditorStateChange={(newEditorState) => onEditorStateChange('dimension2ReliabilityRecommendations', newEditorState)}
                        required={requiredFields.includes('dimension2ReliabilityRecommendations')} //
                    />
                    {errors.dimension2ReliabilityRecommendations && <span className="text-sm" style={{ color: '#AC0C0C' }}>This is a required field</span>}
                </div>

                {/* Add sections for each dimension -3 */}
                <div className="form-group">
                    <label htmlFor="dimension3ValidityRating" className="block text-sm font-medium text-gray-700">Dimension 3: Content Validity Rating Results <span className="text-red-700">*</span></label>
                    <Select
                        inputId="dimension3ValidityRating"
                        options={ratingresultOptions}
                        value={ratingresultOptions.find((option) => option.value === formData.dimension3ValidityRating)}
                        onChange={(value) => handleSelectChange('dimension3ValidityRating', value)}
                        className="mt-1"
                        required={requiredFields.includes('dimension3ValidityRating')} //
                    />
                    {errors.dimension3ValidityRating && <span className="text-sm" style={{ color: '#AC0C0C' }}>This is a required field</span>}
                </div>



                <div className="form-group">
                    <label htmlFor="dimension3ValidityStrength" className="block text-sm font-medium text-gray-700">Dimension 3: Content Validity Areas of Strength <span className="text-red-700">*</span></label>

                    <Editor
                        editorState={editorStates.dimension3ValidityStrength}
                        wrapperClassName="demo-wrapper"
                        toolbarClassName="demo-toolbar-absolute"
                        toolbarOnFocus
                        editorClassName="demo-editor"
                        onEditorStateChange={(newEditorState) => onEditorStateChange('dimension3ValidityStrength', newEditorState)}
                        required={requiredFields.includes('dimension3ValidityStrength')} //
                    />
                    {errors.dimension3ValidityStrength && <span className="text-sm" style={{ color: '#AC0C0C' }}>This is a required field</span>}
                </div>

                <div className="form-group">
                    <label htmlFor="dimension3ValiditySupportingDocs" className="block text-sm font-medium text-gray-700">Dimension 3: Content Validity Supporting Documentation <span className="text-red-700">*</span></label>

                    <Editor
                        editorState={editorStates.dimension3ValiditySupportingDocs}
                        wrapperClassName="demo-wrapper"
                        toolbarClassName="demo-toolbar-absolute"
                        toolbarOnFocus
                        editorClassName="demo-editor"
                        onEditorStateChange={(newEditorState) => onEditorStateChange('dimension3ValiditySupportingDocs', newEditorState)}
                        required={requiredFields.includes('dimension3ValiditySupportingDocs')}
                    />
                    {errors.dimension3ValiditySupportingDocs && <span className="text-sm" style={{ color: '#AC0C0C' }}>This is a required field</span>}
                </div>



                <div className="form-group">
                    <label htmlFor="dimension3ValidityRecommendations" className="block text-sm font-medium text-gray-700">Dimension 3: Content Validity Recommendations for Further Validation  <span className="text-red-700">*</span></label>

                    <Editor
                        editorState={editorStates.dimension3ValidityRecommendations}
                        wrapperClassName="demo-wrapper"
                        toolbarClassName="demo-toolbar-absolute"
                        toolbarOnFocus
                        editorClassName="demo-editor"
                        onEditorStateChange={(newEditorState) => onEditorStateChange('dimension3ValidityRecommendations', newEditorState)}
                        required={requiredFields.includes('dimension3ValidityRecommendations')} //
                    />
                    {errors.dimension3ValidityRecommendations && <span className="text-sm" style={{ color: '#AC0C0C' }}>This is a required field</span>}
                </div>



                {/* Add sections for each dimension -4 */}
                <div className="form-group">
                    <label htmlFor="dimension4CriterionValidityRating" className="block text-sm font-medium text-gray-700">Dimension 4: Criterion Validity Rating Results <span className="text-red-700">*</span></label>
                    <Select
                        inputId="dimension4CriterionValidityRating"
                        options={ratingresultOptions}
                        value={ratingresultOptions.find((option) => option.value === formData.dimension4CriterionValidityRating)}
                        onChange={(value) => handleSelectChange('dimension4CriterionValidityRating', value)}
                        className="mt-1"
                        required={requiredFields.includes('dimension4CriterionValidityRating')} //
                    />
                    {errors.dimension4CriterionValidityRating && <span className="text-sm" style={{ color: '#AC0C0C' }}>This is a required field</span>}
                </div>



                <div className="form-group">
                    <label htmlFor="dimension4CriterionValidityStrength" className="block text-sm font-medium text-gray-700">Dimension 4: Criterion Validity Areas of Strength <span className="text-red-700">*</span></label>

                    <Editor
                        editorState={editorStates.dimension4CriterionValidityStrength}
                        wrapperClassName="demo-wrapper"
                        toolbarClassName="demo-toolbar-absolute"
                        toolbarOnFocus
                        editorClassName="demo-editor"
                        onEditorStateChange={(newEditorState) => onEditorStateChange('dimension4CriterionValidityStrength', newEditorState)}
                        required={requiredFields.includes('dimension4CriterionValidityStrength')} //
                    />
                    {errors.dimension4CriterionValidityStrength && <span className="text-sm" style={{ color: '#AC0C0C' }}>This is a required field</span>}
                </div>

                <div className="form-group">
                    <label htmlFor="dimension4CriterionValiditySupportingDocs" className="block text-sm font-medium text-gray-700">Dimension 4: Criterion Validity Supporting Documentation <span className="text-red-700">*</span></label>

                    <Editor
                        editorState={editorStates.dimension4CriterionValiditySupportingDocs}
                        wrapperClassName="demo-wrapper"
                        toolbarClassName="demo-toolbar-absolute"
                        toolbarOnFocus
                        editorClassName="demo-editor"
                        onEditorStateChange={(newEditorState) => onEditorStateChange('dimension4CriterionValiditySupportingDocs', newEditorState)}
                        required={requiredFields.includes('dimension4CriterionValiditySupportingDocs')} //
                    />
                    {errors.dimension4CriterionValiditySupportingDocs && <span className="text-sm" style={{ color: '#AC0C0C' }}>This is a required field</span>}
                </div>



                <div className="form-group">
                    <label htmlFor="dimension4CriterionValidityRecommendations" className="block text-sm font-medium text-gray-700">Dimension 4: Criterion Validity Recommendations for Further Validation <span className="text-red-700">*</span></label>

                    <Editor
                        editorState={editorStates.dimension4CriterionValidityRecommendations}
                        wrapperClassName="demo-wrapper"
                        toolbarClassName="demo-toolbar-absolute"
                        toolbarOnFocus
                        editorClassName="demo-editor"
                        onEditorStateChange={(newEditorState) => onEditorStateChange('dimension4CriterionValidityRecommendations', newEditorState)}
                        required={requiredFields.includes('dimension4CriterionValidityRecommendations')} //
                    />
                    {errors.dimension4CriterionValidityRecommendations && <span className="text-sm" style={{ color: '#AC0C0C' }}>This is a required field</span>}
                </div>
            </div>



        </div>

    );
};




const ToolForm = () => {
    const [editorStates, setEditorStates] = useState({

        description: EditorState.createEmpty(),
        areasofStrength: EditorState.createEmpty(),
        recommendationsforFurtherValidation: EditorState.createEmpty(),
        dimension1UsefulnessSupportingDocs: EditorState.createEmpty(),
        dimension1UsefulnessStrength: EditorState.createEmpty(),
        dimension1UsefulnessRecommendations: EditorState.createEmpty(),
        dimension2ReliabilitySupportingDocs: EditorState.createEmpty(),
        dimension2ReliabilityStrength: EditorState.createEmpty(),
        dimension2ReliabilityRecommendations: EditorState.createEmpty(),
        dimension3ValiditySupportingDocs: EditorState.createEmpty(),
        dimension3ValidityStrength: EditorState.createEmpty(),
        dimension3ValidityRecommendations: EditorState.createEmpty(),
        dimension4CriterionValiditySupportingDocs: EditorState.createEmpty(),
        dimension4CriterionValidityStrength: EditorState.createEmpty(),
        dimension4CriterionValidityRecommendations: EditorState.createEmpty(),
        // Add more fields as needed
    });
    const [activeTab, setActiveTab] = useState(0);
    const handleTabChange = (index) => {
        setActiveTab(index);
    };

    const [formData, setFormData] = useState({
        toolName: '',
        domain: '',
        domainSubType: [],
        description: '',
        maltreatmentSubTypeOther: '',
        originalToolName: '',
        applicableFields: [],
        administeredBy: [],
        administeredByDetails: '',
        format: [],
        formatDetail: '',
        numOfItems: '',
        adminLength: '',
        trainingRequired: '',
        trainingRequiredDetail: '',
        language: '',
        copyrightAndAccess: [],
        copyrightandAccessDetailsandContact: '',
        linkToTool: '',
        contactInformation: '',
        originalPopulation: '',
        additionalPopulations: '',
        originalSetting: '',
        references: '',
        levelOfEvidence: '',
        additionalSetting: '',
        overallLevelofEvidence: '',
        areasofStrength: '',
        recommendationsforFurtherValidation: '',
        dimension1UsefulnessSupportingDocs: '',
        dimension1UsefulnessRating: '',
        dimension1UsefulnessStrength: '',
        dimension1UsefulnessRecommendations: '',
        dimension2ReliabilitySupportingDocs: '',
        dimension2ReliabilityRating: '',
        dimension2ReliabilityStrength: '',
        dimension2ReliabilityRecommendations: '',
        dimension3ValiditySupportingDocs: '',
        dimension3ValidityRating: '',
        dimension3ValidityStrength: '',
        dimension3ValidityRecommendations: '',
        dimension4CriterionValiditySupportingDocs: '',
        dimension4CriterionValidityRating: '',
        dimension4CriterionValidityStrength: '',
        dimension4CriterionValidityRecommendations: '',
        docid: [Moment(new Date()).format("YYYYMMDDhhmmss")],
        publishDate: Moment(new Date()).format("yyyy-MM-DDTHH:mm:ss"),

    });

    const editor = React.useRef(null);
    const [errors, setErrors] = useState({});
    const [subDomainOptions, setSubDomainOptions] = useState([]);

    // Define which fields are required
    const requiredFields = ['toolName', 'domain', 'applicableFields', 'administeredBy', 'format', 'numOfItems', 'adminLength', 'trainingRequired', 'language', 'linkToTool',
        'copyrightAndAccess', 'contactInformation', 'originalPopulation', 'overallLevelofEvidence', 'levelOfEvidence', 'dimension1UsefulnessRating', 'dimension2ReliabilityRating', 'dimension3ValidityRating', 'dimension4CriterionValidityRating']
    const requiredFields2 = ['description', 'areasofStrength', 'references', 'recommendationsforFurtherValidation',
        'dimension1UsefulnessSupportingDocs', 'dimension1UsefulnessStrength', 'dimension1UsefulnessRecommendations', 'dimension2ReliabilitySupportingDocs',
        'dimension2ReliabilityStrength', 'dimension2ReliabilityRecommendations', 'dimension3ValiditySupportingDocs',
        'dimension3ValidityStrength', 'dimension3ValidityRecommendations', 'dimension4CriterionValiditySupportingDocs',
        'dimension4CriterionValidityStrength', 'dimension4CriterionValidityRecommendations'
    ];

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
        // Clear error when the user types something
        if (value.trim() !== '') {
            setErrors((prevErrors) => ({
                ...prevErrors,
                [name]: '',
            }));
        }

    };


    const handleSelectChange = (name, value) => {
        setFormData((prevData) => ({
            ...prevData,
            [name]: value ? value.value : '',
        }));

    };

    const handleMultiSelectChange = (name, selectedOptions) => {
        setFormData((prevData) => ({
            ...prevData,
            // [name]: selectedOptions.map((option) => option.value),
            [name]: selectedOptions ? selectedOptions.map((option) => option.value) : [],
        }));

    };



    const onEditorStateChange = useCallback((fieldName, newEditorState) => {
        setEditorStates(prevState => ({
            ...prevState,
            [fieldName]: newEditorState,
        }));

    }, []);





    const getEditorHTML = (fieldName) => {
        const currentEditorState = editorStates[fieldName];
        //const contentState = currentEditorState.getCurrentContent();
        // Check if the editor state has content
        if (currentEditorState && currentEditorState.getCurrentContent().hasText()) {
            const contentState = currentEditorState.getCurrentContent();
            return stateToHTML(contentState); // Get HTML version of the editor
        }

        // If no content, return an empty string or handle as needed
        return '';
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();


        const newErrors = {};

        // Check required fields in formData
        requiredFields.forEach((field) => {
            if (
                (!formData[field] || (Array.isArray(formData[field]) && formData[field].length === 0))
            ) {
                const fieldName = field.charAt(0).toUpperCase() + field.slice(1);
                newErrors[field] = `${fieldName} is required`;
            }
        });

        // Check required fields in editorStates
        requiredFields2.forEach((field) => {
            if (
                editorStates[field]?.getCurrentContent &&
                !editorStates[field]?.getCurrentContent().hasText()
            ) {
                const fieldName = field.charAt(0).toUpperCase() + field.slice(1);
                newErrors[field] = `${fieldName} is required`;
            }
        });

        setErrors(newErrors);
        console.log(newErrors)
        // If there are no errors, proceed with form submission
        if (Object.keys(newErrors).length === 0) {
            // Construct the document to send to Elasticsearch
            const doc = {
                toolName: formData.toolName,
                domain: formData.domain,
                domainSubType: formData.domainSubType || [],
                maltreatmentSubTypeOther: formData.maltreatmentSubTypeOther,
                description: getEditorHTML('description'), // Using description field as an example
                // Add other fields here as needed
                originalToolName: formData.originalToolName,
                applicableFields: formData.applicableFields || [],
                administeredBy: formData.administeredBy || [],
                administeredByDetails: formData.administeredByDetails,
                format: formData.format || [],
                formatDetail: formData.formatDetail,
                numOfItems: formData.numOfItems,
                adminLength: formData.adminLength,
                trainingRequired: formData.trainingRequired,
                trainingRequiredDetail: formData.trainingRequiredDetail,
                language: formData.language,
                copyrightAndAccess: formData.copyrightAndAccess || [],
                copyrightandAccessDetailsandContact: formData.copyrightandAccessDetailsandContact,
                linkToTool: formData.linkToTool,
                contactInformation: formData.contactInformation,
                originalPopulation: formData.originalPopulation,
                additionalPopulations: formData.additionalPopulations,
                originalSetting: formData.originalSetting,
                references: getEditorHTML('references'),
                levelOfEvidence: formData.levelOfEvidence,
                additionalSetting: formData.additionalSetting,
                overallLevelofEvidence: formData.overallLevelofEvidence,
                areasofStrength: getEditorHTML('areasofStrength'),
                recommendationsforFurtherValidation: getEditorHTML('recommendationsforFurtherValidation'),
                dimension1UsefulnessSupportingDocs: getEditorHTML('dimension1UsefulnessSupportingDocs'),
                dimension1UsefulnessRating: formData.dimension1UsefulnessRating,
                dimension1UsefulnessStrength: getEditorHTML('dimension1UsefulnessStrength'),
                dimension1UsefulnessRecommendations: getEditorHTML('dimension1UsefulnessRecommendations'),
                dimension2ReliabilitySupportingDocs: getEditorHTML('dimension2ReliabilitySupportingDocs'),
                dimension2ReliabilityRating: formData.dimension2ReliabilityRating,
                dimension2ReliabilityStrength: getEditorHTML('dimension2ReliabilityStrength'),
                dimension2ReliabilityRecommendations: getEditorHTML('dimension2ReliabilityRecommendations'),
                dimension3ValiditySupportingDocs: getEditorHTML('dimension3ValiditySupportingDocs'),
                dimension3ValidityRating: formData.dimension3ValidityRating,
                dimension3ValidityStrength: getEditorHTML('dimension3ValidityStrength'),
                dimension3ValidityRecommendations: getEditorHTML('dimension3ValidityRecommendations'),
                dimension4CriterionValiditySupportingDocs: getEditorHTML('dimension4CriterionValiditySupportingDocs'),
                dimension4CriterionValidityRating: formData.dimension4CriterionValidityRating,
                dimension4CriterionValidityStrength: getEditorHTML('dimension4CriterionValidityStrength'),
                dimension4CriterionValidityRecommendations: getEditorHTML('dimension4CriterionValidityRecommendations'),
                publishDate: formData.publishDate,
                docid: formData.docid
            };

            console.log(doc);

            try {
                const response = await axios.post(process.env.REACT_APP_URL + '/' + process.env.REACT_APP_NAME + '/_doc', doc, {
                    headers: {
                        'Authorization': 'Basic ' + btoa(process.env.REACT_APP_KEY),  // Use btoa() instead of Buffer
                        'Content-Type': 'application/json',
                    }
                });
                console.log('Successfully indexed:', response.data);
                alert('Form submitted successfully!');
                // Reset to page 1 after submission

                setFormData({
                    ...formData,
                    toolName: '',
                    domain: '',
                    domainSubType: [],
                    maltreatmentSubTypeOther: '',
                    description: EditorState.createEmpty(),
                    originalToolName: '',
                    applicableFields: [],
                    administeredBy: [],
                    administeredByDetails: '',
                    format: [],
                    formatDetail: '',
                    numOfItems: '',
                    adminLength: '',
                    trainingRequired: '',
                    trainingRequiredDetail: '',
                    language: '',
                    copyrightAndAccess: [],
                    copyrightandAccessDetailsandContact: '',
                    linkToTool: '',
                    contactInformation: '',
                    originalPopulation: '',
                    additionalPopulations: '',
                    originalSetting: '',
                    references: EditorState.createEmpty(),
                    levelOfEvidence: '',
                    additionalSetting: '',
                    overallLevelofEvidence: '',
                    areasofStrength: '',
                    recommendationsforFurtherValidation: EditorState.createEmpty(),
                    dimension1UsefulnessSupportingDocs: EditorState.createEmpty(),
                    dimension1UsefulnessRating: '',
                    dimension1UsefulnessStrength: EditorState.createEmpty(),
                    dimension1UsefulnessRecommendations: '',
                    dimension2ReliabilitySupportingDocs: '',
                    dimension2ReliabilityRating: '',
                    dimension2ReliabilityStrength: '',
                    dimension2ReliabilityRecommendations: '',
                    dimension3ValiditySupportingDocs: '',
                    dimension3ValidityRating: '',
                    dimension3ValidityStrength: '',
                    dimension3ValidityRecommendations: '',
                    dimension4CriterionValiditySupportingDocs: '',
                    dimension4CriterionValidityRating: '',
                    dimension4CriterionValidityStrength: '',
                    dimension4CriterionValidityRecommendations: '',
                }); // Reset form

                setEditorStates({
                    description: EditorState.createEmpty(),
                    areasofStrength: EditorState.createEmpty(),
                    recommendationsforFurtherValidation: EditorState.createEmpty(),
                    references: EditorState.createEmpty(),
                    dimension1UsefulnessSupportingDocs: EditorState.createEmpty(),
                    dimension1UsefulnessStrength: EditorState.createEmpty(),
                    dimension1UsefulnessRecommendations: EditorState.createEmpty(),
                    dimension2ReliabilitySupportingDocs: EditorState.createEmpty(),
                    dimension2ReliabilityStrength: EditorState.createEmpty(),
                    dimension2ReliabilityRecommendations: EditorState.createEmpty(),
                    dimension3ValiditySupportingDocs: EditorState.createEmpty(),
                    dimension3ValidityStrength: EditorState.createEmpty(),
                    dimension3ValidityRecommendations: EditorState.createEmpty(),
                    dimension4CriterionValiditySupportingDocs: EditorState.createEmpty(),
                    dimension4CriterionValidityStrength: EditorState.createEmpty(),
                    dimension4CriterionValidityRecommendations: EditorState.createEmpty(),
                    // Add more fields as needed
                });
                // Scroll to the top of the page or to a specific element
                window.scrollTo(0, 0); // This will scroll to the top of the page
            } catch (error) {
                console.error('Error indexing data:', error.response || error);
                alert('Failed to submit form.');
            }
        }

    };


    const insertImage = (imageUrl, altText) => {
        const contentState = editorStates.getCurrentContent();
        const contentStateWithEntity = contentState.createEntity('IMAGE', 'IMMUTABLE', {
            src: imageUrl,
            alt: altText
        });
        const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
        const newEditorState = DraftEditorState.push(editorStates, contentStateWithEntity, 'insert-characters');
        setEditorStates(DraftEditorState.moveFocusToEnd(newEditorState));
    };
    console.log(formData)
    return (
        <Layout>
            <div class="grid gap-6 pt-2 " style={{ paddingBottom: 20 + "px" }} >
                <div class="row card-header pt-2 text-sm" style={{ paddingBottom: 20 + "px" }} ><span style={{ paddingLeft: 10 + "px" }}><a href="/">Home</a>/Resource Upload</span></div>


                <div className="mx-auto bg-white shadow-md rounded-lg mx-auto w-full md:w-3/4 row body_content">
                    <h1 className="text-2xl font-semibold pb-4 mb-6">Adult Protective Services Tools Inventory: New Form</h1>
                    <p>Please fill out the form and submit the data.</p>

                    <div>
                        <div className="flex space-x-4 border-b-2">
                            <button
                                className={`py-2 px-4 text-lg font-medium ${activeTab === 0 ? 'bg-gray-300 text-black' : 'bg-blue-700 text-white'
                                    } rounded-t-lg`}
                                onClick={() => handleTabChange(0)}
                            >
                                Resource Materials
                            </button>
                            <button
                                className={`py-2 px-4 text-lg font-medium ${activeTab === 1 ? 'bg-gray-300 text-black' : 'bg-blue-700 text-white'
                                    } rounded-t-lg`}
                                onClick={() => handleTabChange(1)}
                            >
                                Supplemental Materials
                            </button>
                        </div>

                        <form onSubmit={handleSubmit}>
                            {activeTab === 0 && (
                                <div>
                                    <FormPage1
                                        formData={formData}
                                        editorStates={editorStates}

                                        handleMultiSelectChange={handleMultiSelectChange}
                                        handleSelectChange={handleSelectChange}
                                        handleChange={handleChange}
                                        onEditorStateChange={onEditorStateChange}
                                        insertImage={insertImage}
                                        errors={errors}
                                        requiredFields={requiredFields}
                                    />

                                </div>
                            )}

                            {activeTab === 1 && (
                                <div>
                                    <FormPage2
                                        formData={formData}
                                        editorStates={editorStates}
                                        handleMultiSelectChange={handleMultiSelectChange}
                                        handleSelectChange={handleSelectChange}
                                        handleChange={handleChange}
                                        onEditorStateChange={onEditorStateChange}
                                        insertImage={insertImage}
                                        errors={errors}
                                        requiredFields={requiredFields} />

                                </div>
                            )}

                            <div className="form-group">
                                <div className="grid grid-cols-1 gap-6 lg:grid-cols-1 mb-8">

                                    <div className="mx-auto">
                                        <button
                                            type="submit"
                                            className="mt-6 px-6 py-2 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 focus:outline-none"
                                            onClick={handleSubmit}
                                        >
                                            Submit Resource
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>


                </div>
            </div>
        </Layout>
    );
};

export default ToolForm;